export type FeatureFlagsState = Record<FeatureFlagEnum, boolean>;

export interface FeatureFlagsStore {
  flags: FeatureFlagsState;
}

export enum FeatureFlagEnum {
  GoogleLocationSearch = 'google_location_search',
  ReplaySession = 'replay_session',
  DisplayCid = 'cid',
  DisableIntercom = 'disable_intercom',
  ShowAdditionalPropertyTypes = 'show_additional_property_types',
  ShowCPLGroupBooking = 'show_cpl_group_booking',
  ShowCPLMeetingVenue = 'show_cpl_meeting_venue',
  UseBookingsModuleFromMonorepoLibrary = 'bookings_module_to_library',
  UseClientsiteAuthApp = 'clientsite_auth_app',
  RoomexPayPortal = 'roomexpay_portal',
  RoomexPayReports = 'roomexpay_reports',
  EnableRoomexPayVat = 'enable_roomexpay_vat',
  ShowTrainlineTicketsButton = 'show_get_trainline_tickets_btn',
  SaverplusSameDayRate = 'saverplus_same_day_rate',
  SpendType = 'spend_type',
  OverrideUSRegionalSettings = 'override_us_regional_settings',
  TrainlineShowAllReports = 'trainline_show_all_reports',
  ClientsiteGuestbook = 'clientsite_guestbook',
  TemporaryApprover = 'temporary_approver',
  UseReportV2Trainline = 'use_report_v2_trainline',
  UseReportV2CustomReports = 'use_report_v2_customreports',
  UseReportV2WorkforceTracker = 'use_report_v2_workforcetracker',
  LoyaltyViaSpecialRequest = 'loyalty_via_special_request',
  UseSummaryReservationDetailsComponent = 'use_summary_reservation_details_component',
  MinimumNumberOfFoundLocations = 'minimum_number_of_found_locations',
  NavigateToRoomDetailsInNewTab = 'navigate_to_room_details_new_tab',
  UseDefaultLocale = 'use_default_locale',
  ShowHotelLoyalty = 'show_hotel_loyalty',
  ShowLoyaltyGuaranteed = 'show_loyalty_guaranteed',
  ShowCO2Emissions = 'co2_emission',
  DatepickerTabs = 'datepicker_tabs',
  ShowTruckParkingFilter = 'show_truck_parking_filter',
  recentSearchesPillsEnabled = 'recent_searches_pills_enabled',
  Long_Stay_Redirect_Modal = 'long_stay_redirect_modal',
  MergeHotelDetails_RoomSelectPage = 'merge_hotel_details_room_select_page',
  LocationSearchSplitMapView = 'location_search_split_map_view',
  EnableMapViewBoundedSearch = 'enable_map_view_bounded_search',
  UseBrandConfigValue = 'use_brand_config_value',
  EnableSecondHotelSearchStandardRoom = 'enable_second_hotel_search_standard_room',
  EnableInviteUsers = 'enable_invite_user',
  EnableUploadUserList = 'enable_upload_user_list',
  EnableLodgxApiDomain = 'enable_lodgx_api_domain',
  EnableLocalDefaultFilters = "enable_local_default_filters",

  // Experiments
  Experiment_Stay_917 = 'experiment_STAY_917',
  Experiment_Stay_924 = 'experiment_STAY_924',
  Experiment_Stay_958 = 'experiment_STAY_958',
  Poc_enable_no_rooms_workflow = 'poc_enable_no_rooms_workflow',
  Enable_occupancy_search = 'enable_occupancy_search',
}
